import React, { useContext } from 'react';
import { Tooltip } from 'antd';

// Advanced-edit gate for journey editing. Default `true` = fail-open: a control renders
// enabled unless a page explicitly provides `value={hasAdvanced}`. (Tests that render
// without a provider get the default, so they are unchanged.)
export const AdvancedEditContext = React.createContext(true);

// Wrap a SINGLE control to gate it behind advanced-edit access. Advanced users see the
// control untouched; others see it inert (disabled / onClick removed / greyed) with a
// tooltip. TEMPORARY scaffolding — to graduate a feature to all beta users, delete the
// wrapper. `grep AdvancedOnly` lists everything still gated.
export default function AdvancedOnly({ children, tip = 'Advanced editing access required' }) {
  const advanced = useContext(AdvancedEditContext);
  if (advanced) return children;
  const child = React.Children.only(children);
  const inert = React.cloneElement(child, {
    disabled: true,             // antd Button/Input/Select/Switch + native controls
    onClick: undefined,         // icons/divs (EditOutlined, .tl-add) ignore `disabled` — drop the handler
    'aria-disabled': true,
    className: `${child.props.className || ''} is-advanced-disabled`.trim(),
  });
  // The span both (a) gives antd Tooltip a hover target for a disabled/inert child and
  // (b) insulates the child's className/props from Tooltip's own cloneElement. Absolutely
  // positioned children (the canvas .tl-add `+`) are gated inline instead — a wrapper span
  // collapses to zero-size for them and anchors the tip at the canvas origin.
  return <Tooltip title={tip}><span className="advanced-gate">{inert}</span></Tooltip>;
}
